<script setup lang="ts">
import { StoryblokRichText } from '@storyblok/vue';

interface TextBlok {
    _uid: string;
    headline: string;
    content: object;
    text_align: string;
    background_color: string;
    cta_text?: string;
    cta_link?: { cached_url: string; url: string };
}

const props = defineProps<{ blok: TextBlok }>();

function resolveLink(link: { cached_url: string; url: string } | undefined): string {
    return link?.cached_url || link?.url || '#';
}
</script>

<template>
    <section
        v-editable="blok"
        class="py-12 xl:py-20"
        :class="blok.background_color === 'warm' ? 'bg-[#FCEEE6]' : blok.background_color === 'light' ? 'bg-[#FCF7F4]' : 'bg-white'"
    >
        <div
            class="mx-auto max-w-4xl px-4 text-center"
            :class="blok.text_align === 'center' ? 'md:text-center' : 'md:text-left'"
        >
            <h2 v-if="blok.headline" class="mb-6 text-[28px] font-semibold leading-tight text-[#004646] xl:mb-8 xl:text-4xl">
                {{ blok.headline }}
            </h2>
            <div class="prose prose-lg max-w-none text-[#393734]">
                <StoryblokRichText v-if="blok.content" :doc="blok.content" />
            </div>
            <a
                v-if="blok.cta_text"
                :href="resolveLink(blok.cta_link)"
                class="mt-8 inline-block rounded-lg bg-[#F08E59] px-8 py-4 text-lg font-semibold text-white shadow-orange-button transition hover:opacity-90"
            >
                {{ blok.cta_text }}
            </a>
        </div>
    </section>
</template>
